/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import { API } from "aws-amplify";
import { playersByStarTotal } from "../graphql/queries";

const state = {
  currentPage: [],
};

const getters = {};

const actions = {
  async loadPage({ commit }, nextToken) {
    commit("setIsLoading", true, { root: true });
    const response = await API.graphql({
      query: playersByStarTotal,
      variables: {
        purpose: "score",
        starTotal: { gt: 0 },
        sortDirection: "DESC",
        nextToken: nextToken,
      },
    });
    console.log(`Leaderboard page: ${JSON.stringify(response)}.`);
    for (let i = 0; i < response.data.playersByStarTotal.items.length; i++) {
      response.data.playersByStarTotal.items[i].rank = i + 1;
    }
    commit("setCurrentPage", response.data.playersByStarTotal.items);
    commit("setIsLoading", false, { root: true });
  },
};

const mutations = {
  setCurrentPage(state, page) {
    state.currentPage = page;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
